import { all, fork } from 'redux-saga/effects';
import externalUserSaga from './ExternalUsers/externaluserSaga';
import internalUserSaga from './InternalUsers/internaluserSaga';
import AnalyticsSaga from './analyticsReports/analyticsReportSaga';
import assessmentCycleSaga from './assessmentCycles/assessmentCycleSaga';
import manageSkillsSaga from './manageSkills/manageSkillsSaga';
import questionBankSaga from './questionBanks/questionBanksSaga';
import assessmentReportSaga from './reports/assessmentReportSaga';
import cycleReportSaga from './reports/cycleReportSaga';
import externalCandidateReportsSaga from './reports/externalCandidateReportSaga';
import selfAssessmentSaga from './reports/selfAssessmentReportSaga';
import userListSaga from './userAnalysis/userAnalysisSaga';
import userSaga from './users/userSaga';

import manageEmployeeCyclesSaga from './ManageEmployeeCycle/ManageEmployeeCycleSaga';
import manageEmployeeExternalSaga from './ManageExternalUsers/ManageExternalUsersSaga';
import approveReviewModificationsSaga from './approveReviewModifications/approveReviewModificaionsSaga';
import manageAssessorSaga from './manageAssessor/manageAssessorSaga';
import manageEmployeeSaga from './manageEmployees/manageEmployeeSaga';
import technicalAssessmentsSaga from './technicalAssessments/technicalAssessmentsSaga';

import manageSMESaga from './manageSME/manageSMESaga';
import userNotificationSaga from './notifications/userNotificationSaga';
import questionBankReview from './questionBankReview/questionBankReviewSaga';
import technicalQuestionBankSaga from './technicalQuestionBank/technicalQuestionBankSaga';
import manageEmailSaga from './ManageEmail/ManageEmailSaga';
import manageCurrentCycleSaga from './GetCurrentCycle/GetCurrentCycleSaga';
import getAllEmployeesSaga from './Employees/GetAllEmployeesSaga';
import watchSaveCycleChanges from './SaveCycleChanges/SaveCycleChangesSaga';
import emailTypesSaga from './EmailTypes/EmailTypesSaga';
import watchFetchSelfAssessment from './SelfAssessmentScreen/SelfAssessmentScreenSaga';
import watchEmailSagas from './SendWelcomeEmail/SendWelcomeEmailSaga';

const rootSaga = function* () {
  yield all([
    fork(userSaga),
    fork(assessmentCycleSaga),
    fork(questionBankSaga),
    fork(userListSaga),
    fork(AnalyticsSaga),
    fork(externalCandidateReportsSaga),
    fork(selfAssessmentSaga),
    fork(cycleReportSaga),
    fork(assessmentReportSaga),
    fork(manageSkillsSaga),
    fork(manageEmployeeSaga),
    fork(manageEmployeeCyclesSaga),
    fork(manageAssessorSaga),
    fork(manageEmployeeExternalSaga),
    fork(externalUserSaga),
    fork(internalUserSaga),
    fork(technicalAssessmentsSaga),
    fork(approveReviewModificationsSaga),
    fork(questionBankReview),
    fork(technicalQuestionBankSaga),
    fork(manageSMESaga),
    fork(userNotificationSaga),
    fork(manageSMESaga),
    fork(manageEmailSaga),
    fork(manageCurrentCycleSaga),
    fork(getAllEmployeesSaga),
    fork(watchSaveCycleChanges),
    fork(emailTypesSaga),
    fork(watchFetchSelfAssessment),
    fork(watchEmailSagas)
  ]);
};

export default rootSaga;
